import { Controller } from "../../../Controller";
import { ListarDocumentosProdutoService } from "../../../../Services/Geral/Documentos/DocumentoProduto/DocumentoProdutoServices";

export async function ListarDocumentosProdutoController(idProduto: number) {
    return Controller(ListarDocumentosProdutoService(idProduto, false));
}

export async function ListarDocumentosUnidadeController(idProduto: number) {
    return Controller(ListarDocumentosProdutoService(idProduto, true));
}
